import React from "react";
import { Box } from "@mui/material";
import Section from "../../common/components/Section";
import SubSection from "../../common/components/SubSection";
import Title from "../../common/components/Title";
import Number from "../../common/components/Number";
import Topic from "../../common/components/Topic";
import Text from "../../common/components/Text";
import Content from "../../common/components/Content";
import Bullet from "../../common/components/Bullet";
import Picture from "../../common/components/Picture";
import brotherlyLove from "../../images/Brotherly Love.png";
import allegory from "../../images/Allegory of Peace.png";
import blood from "../../images/Blood of Jesus.png";
import eyes from "../../images/Eyes enlightened.png";
import fhc from "../../images/Faith, Hope, Charity.png";
import jesusChrist from "../../images/Jesus Christ.png";
import levites from "../../images/Levites.jpg";
import nebuchadnezer from "../../images/Nebuchadnezer.png";
import newBirth from "../../images/New Birth.png";
import paulWay from "../../images/Paul way to Damascus.png";
import tenCommandments from "../../images/Ten commandments.png";
import theWorld from "../../images/The World.png";
import treeOfPeace from "../../images/Tree of Peace.png";
import treeOfRighteousness from "../../images/Tree of Righteousness.png";
import water from "../../images/Water.png";
import whatIsSin from "../../images/What is sin.png";
import dayTwo from "../../images/day2.png";
import WithLove from "../../common/components/WithLove";
import Subtitle from "../../common/components/Subtitle";
import Italics from "../../common/components/Italics";

export default function DayTwo() {
  return (
    <>
      <Box>
        <Topic>The Kingdom of Christ &ndash; Righteousness and Peace</Topic>
        <Text>John 3:3, Ephesians 5:5, 4:24, Romans 8:6</Text>
      </Box>
      <Section>
        <Picture src={dayTwo} />
        <SubSection>
          <br />
          <Title>STUDY BACKGROUND</Title>
          <Content>
            We have found grace to consider elaborately through
            yesterday&rsquo;s lesson, what the kingdom of God truly is as
            against some of the common misconceptions about the kingdom of God,
            and the processes involved in coming into the kingdom. In
            continuation, we trust God to take us further into the subject as we
            zoom into the kingdom in detail, beginning with the kingdom of
            Christ.
            <br />
            <br />
            The disobedience of Adam opened the door for sin to enter into the
            world. Over time, sin designed a system of life for men to live on
            the earth. This system of life is called &#8220;this present
            world&#8221;. As men lived by this system, they evolved from the
            living soul state to flesh.
            <br />
            <br />
            Here, we would be expounding the subject of Sin, the World, and
            Flesh and how the Kingdom of Christ is God&rsquo;s provision to
            deliver man from the bondage of sin.
          </Content>
        </SubSection>
        <SubSection>
          <Number number={1}>
            <b>What is Sin? </b>
            <br /> To properly uncover what sin is, we need to track back its
            origin. <Picture src={whatIsSin} />
            Sin was first found in the Cherub who fell &ndash; Lucifer{" "}
            <b>(Eze. 28:16)</b> &ndash; and made its way into the human race
            when Adam disobeyed God by eating of the tree of the knowledge of
            good and evil <b>(Gen 4:7. Rom 5:12).</b> So, we see that the very
            fiber of sin is knowledge and understanding.
            <br />
            <br /> Although some schools of thought suggest that the tree of the
            knowledge of good and evil was planted by God to prove Adam&rsquo;s
            obedience, scriptures make us understand that a tree (with its
            source) is known by its fruit (or end product){" "}
            <b>(Mat. 7:16&ndash;20). </b>
            <br />
            <br />
            We know the source of the tree of the knowledge of good and evil by
            the effect it had on Adam and Eve. Their eyes were opened to the
            possibility of a life of sufficiency outside of God and mankind
            began to degenerate in a downward spiral of destruction from then.
            We can trace this outcome to Satan{" "}
            <b>(Jhn. 10:10, Isa. 14:13&ndash;14).</b> <br />
            <br />
            It becomes clear therefore that the tree of the knowledge of good
            and evil was planted by Satan to tempt Adam and contained within
            that tree was the very nature of sin. This makes us know that sin
            transcends man because it originated from the angelic. Sin is older
            than man because it originated from an angel <b>(Eze. 28:15).</b>
            Therefore, we can say that sin and death is the life found in an
            angel, i.e., Lucifer now turned Satan.
          </Number>
          <br />
          <Number number={2}>
            <b>What is the World? </b>
            <br /> The World is not referring to the physical earth structure
            but a system of life designed by Satan and evil spirits.
            <br /> <br />
            <Picture src={theWorld} />
            <br />
            <br />
            This system of life was crafted by Satan so that men are fashioned
            by it to become Flesh. This World system is the brainchild of the
            wicked formulated to keep men perpetually in a state of carnality{" "}
            <b>(1 Jhn. 5:19, 2 Cor. 4:4, Jhn. 14:30).</b> According to Eph.
            2:1&ndash;3, this world is a course of learning in which every man
            born on earth enrolls into it, is raised by it, and is made flesh in
            it.
          </Number>
          <br />
          <Number number={3}>
            <b>What is flesh? </b>
            <br /> Flesh speaks of the fallen nature of man. In <b>
              Gen. 6:3,
            </b>{" "}
            we see the extent of degradation of the soul of man. The Man God
            created, in the beginning, had fallen from the Living Soul state to
            becoming flesh. Flesh defines the fallen state of the soul in which
            the soul is no longer subject to the law of God. This is also known
            as carnality. <br />
            <br />
            It is good to know however that the fall of man is different from
            the death of man in his spirit. Adam died in his spirit by eating
            the fruit of the Tree of the Knowledge of Good and Evil. But, the
            fall of man refers to the departure of the soul from God over time.
            This means that the death of Man in his spirit was instantaneous but
            the death in the soul happens in a process of time. <br />
            <br />
            Satan framed this world in sin and tutored man in it until he became
            Flesh. <b>(Ecl. 3:19, 1 Cor. 3:3, Rom. 8:5).</b> Flesh is a man that
            values vanity i.e., Flesh is a soul that values anything that can
            pass away <b>(1 Pet. 1:24).</b>
            <br /> <br />
            <Picture src={nebuchadnezer} />
            <br />
            <br />
            Vanity is anything that reduces the weight of the soul, anything
            outside of God falls under vanity.
          </Number>
        </SubSection>
        <SubSection>
          <Content>
            Overtime, as man lived by the law of sin, he became a captive of sin
            and came under its dominion. This resulted in a translation of the
            soul from the reign of the Living soul to the reign of sin and death
            <b> (Rom. 6:16).</b> As man continued in sin, he was translated from
            the Kingdom of Light – in which God created Adam, to the Kingdom of
            Darkness. Christ is the provision of God to redeem man from sin and
            death and from its dominion (Kingdom).
          </Content>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>WHAT IS CHRIST</Title>
          <br />
          <Picture src={jesusChrist} />
          <br /> <br />
          <Content>
            The word &lsquo;Christ&rsquo; means &lsquo;the anointed one&rsquo;,
            it is the Greek interpretation for &lsquo;the Messiah &ndash; the
            promised deliverer of the Jews&rsquo; <b>(Jhn. 1:41).</b> The Jews
            had entertained many &lsquo;anointed ones&rsquo; in the scriptures
            under the old covenant, such men stood in the offices of kings,
            prophets, and judges to deliver the children of Israel from the
            tyranny of God&rsquo;s enemies. Examples of such men were David,
            Moses, Samson, and Deborah.
            <br />
            <br /> However, the mandate of our Lord Jesus as &lsquo;the
            Christ&rsquo; is tied to a commission to deliver God&rsquo;s people
            not from the bondage of a physical tyranny but from the dominion of
            sin and death <b>(Mat. 1:21, Rom. 8:1&ndash;2).</b> Christ here is
            not talking about the personality of Jesus but a nature of Life that
            is in him. This life is accessed by the understanding of the mystery
            of Christ and obedience to it. Jesus was the first man that
            downloaded this mystery from God, grew into it and embodied it. He
            eventually became Jesus the Christ.
            <br />
            <br /> Understanding both the fabric and the origin of sin can help
            us to more accurately understand the operation of Christ. Sin is a
            kind of life resulting from an understanding, as we have already
            established and Christ is an understanding rooted in a life that is
            seated inside Jesus&rsquo; soul. The deliverance Christ brings comes
            through an inner transformation through the knowledge of the truth{" "}
            <b>(John 8:31&ndash;32).</b> <br />
            <br />
            We would be looking at scriptural patterns of Christ in the
            subtopics below:
          </Content>
          <br />
          <Number number={1}>
            <b>The new man (Eph. 4:24, Col. 3:10)</b> <br />
            The activity of sin upon the soul gave man age in death and brought
            about the old man. The working of Christ reverses this aging process
            in sin and restores the soul to a new man. The old man by identity
            is sin <b>(Rom. 6:6),</b> the new man by identity is Christ{" "}
            <b>(2 Cor. 5:17).</b>
          </Number>
          <br />
          <Number number={2}>
            <b>
              Faith, Hope, Charity (1 Cor. 13:13, 1 Thess. 1:3, 1 Tim. 1:14, 1
              Cor. 10:4)
            </b>{" "}
            <br />
            <br />
            <Picture src={fhc} />
            <br />
            <br />
            Christ, who is the new man, can be more clearly seen through its
            laws. Faith, Hope, and Charity are the laws of the life in Christ
            that culminate in the new man.
          </Number>
          <br />
          <Number number={3}>
            <b>Righteousness and Peace (Rom. 14:17, Rom. 9:4)</b> <br />
            Covenants are made when laws are engaged. Christ life can also be
            understood by its covenants. Righteousness and Peace are the
            covenants of Christ life that are made as a result of keeping the
            law of Christ.
          </Number>
          <br />
          <Number number={4}>
            <b>Life and godliness (2 Pet. 1:3)</b> <br />
            Every life form is identified by its nature. We are able to separate
            one person from the other by their different natures. Life and
            godliness are the two natures of Christ life as seen in scriptures.
            Engaging Christ laws would first result in a nature called “life”,
            and then “godliness”.
          </Number>
          <br />
          <Number number={5}>
            <b>
              Wisdom, Righteousness, Sanctification, and Redemption (1 Cor.
              1:30)
            </b>{" "}
            <br />
            These speaks of the course of learning Christ or the process to
            attaining Christ. A person who is engaging Christ law and making
            covenant would experience these. Christ is introduced first as
            wisdom, then righteousness, then sanctification, and finally
            redemption.
          </Number>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>UNDERSTANDING PAUL&rsquo;S COMMISSION</Title>
          <Content>
            <Italics>
              &#8220;To open their eyes, and to turn them from darkness to
              light, and from the power of Satan unto God, that they may receive
              forgiveness of sins, and inheritance among them which are
              sanctified by Faith that is in me&#8221; &ndash; <b>Acts 26:18</b>
            </Italics>
            <br />
            Apostle Paul received commission of the Lord Jesus to preach Christ
            to the Jews and to the Gentiles <b>(Rom. 1:14&ndash;16).</b>
            <br />
            <br />
            <Picture src={paulWay} />
            <br />
            <br />
            <Content>
              His encounter on his way to Damascus as accounted in{" "}
              <b>Acts. 26:12&ndash;18</b> captures completely the curriculum of
              learning Christ. This commission uncovers the workings of sin and
              the activities of Christ learning in delivering us from the
              dominion of sin and giving us an inheritance in God&rsquo;s
              kingdom <b>(Col. 1:13).</b> From the scripture above, we&rsquo;d
              be looking at
            </Content>
            <br />
            <Bullet>
              <b>To open their eyes:</b> This helps us identify the first thing
              sin did in the soul: to close our eyes and shut down our sight. It
              also helps us to see the first thing Christ comes to do: to open
              our eyes and to restore our sight <b>(Gen 3:7, Eph. 1:18).</b>
            </Bullet>
            <br />
            <br />
            <Picture src={eyes} />
            <br />
            <br />
            <Bullet>
              <b>To turn them from darkness to light:</b> Following the
              restoration of our sight, Christ knowledge would turn us away from
              the kingdom of darkness and in the direction of God&rsquo;s
              kingdom so that we can begin to seek the kingdom
              <b> (Eph. 5:8).</b>
            </Bullet>
            <br />
            <Bullet>
              <b>To turn them from the power of Satan unto God:</b> By engaging
              the power in Christ through obedience, the soul breaks free from
              the power of Satan and is brought gradually under the dominion of
              God&rsquo;s reign <b>(Col. 1:13).</b>
            </Bullet>
            <br />
            <Bullet>
              <b>That they may receive forgiveness of sins:</b>
              Forgiveness (or remission) in Christ is not merely pardon for
              faults. It comes as a result of learning and using the truth that
              is contained in Christ.
            </Bullet>
            <br />
            <Bullet>
              <b>
                And an inheritance among them which are sanctified by faith that
                is in me:
              </b>
              There is an inheritance in the kingdom of Christ{" "}
              <b>(Eph. 5:5).</b> This inheritance is the crown of the dominion
              of Christ life. It is those who have learned Christ and have been
              sanctified who qualify for this inheritance. This inheritance is
              also described in Scriptures as the redemption of the soul{" "}
              <b>(Eph. 1:14, 1 Cor. 1:30).</b>
            </Bullet>
          </Content>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>Righteousness</Title>
          <br />
          <Picture src={treeOfRighteousness} />
          <br />
          <br />
          <Subtitle>
            <b>What is Righteousness?</b>
          </Subtitle>
          <Content>
            Morality and piety as demonstrated by men is what many erroneously
            describe as righteousness, however, according to scriptures,
            righteousness is not the ability to keep certain moral standards but
            is simply that which is &lsquo;right&rsquo; in the sight of God. In
            other words, righteousness is the lifestyle, or standard for living
            that God approves. <br />
            <br />
            From the flip side, as we have seen earlier, sin also is a lifestyle
            or way that seems right/righteous according to the judgement of men{" "}
            <b>(Prov. 14:12, 21:2).</b> Hence, the best of men in the world live
            by a righteousness prescribed by sin until that which is
            &#8216;right&#8217; according to God is revealed{" "}
            <b>(Gen. 2:17, Isa. 64:6, Phil 3:9).</b> <br />
            <br />
            Righteousness is the first life in the kingdom that must be revealed
            through preaching and obeyed, for entrance to be granted into the
            kingdom of God <b>(Rom. 14:17, Psa. 118:19).</b> This righteousness
            is conveyed through the preaching and teaching of the gospel of
            Christ{" "}
            <b>
              (Matt. 4:23, Acts. 15:35, 28:30&ndash;31, Rom. 1:16&ndash;17).{" "}
            </b>
            The heralding of the kingdom begins with the revelation of
            righteousness, as the kind of man that can enter the kingdom is one
            who has learned the righteousness of the kingdom{" "}
            <b>(Psa. 118:20, Isa. 26:2).</b>
            <br />
            <br /> As righteousness is being revealed through the gospel,
            certain thoughts, ideologies, principles, value system, traditions
            and philosophies of the believer are demanded to be given up{" "}
            <b>(Col. 2:8, Mat. 13:45&ndash;46, Mk. 10:21&ndash;23).</b> These
            thoughts, ideologies, and principles are strongholds that makes men
            seek after vanity (anything that can pass away); which is the
            lifestyle of the Gentiles{" "}
            <b>(Matt. 6:32, Eph. 4:17, Rom. 3:10&ndash;11).</b>
            <br />
            <br /> Righteousness can be understood from different scriptural
            perspective. One of which is the remission of sins.
          </Content>
          <br />
          <Bullet>
            <b>Remission of Sins (Rom. 3:25)</b>
            <br />
            Remission of sins is not just pardon of a person&rsquo;s faults but
            the deliverance or removal of sin within the soul. It is the process
            of deleting the laws and nature of sin from man&rsquo;s soul by the
            preaching of the gospel <b>(Mk. 1:4).</b> We see from{" "}
            <b>Rom. 3: 25,</b> that as one learns righteousness, the laws of sin
            in the soul are remitted/purged/cleansed. Another way to describe
            remission of sins from the scriptures, is the forgiveness of sins{" "}
            <b>(Act. 26:18, Eph. 1:7).</b>
            <br />
            <br />
            <Picture src={blood} />
            <br />
            <br />
            This work of remission cannot be accomplished in a man simply by his
            determination or desire. It takes place whenever the light of the
            word enlightens the heart and there is a commensurate agreement of
            the heart to turn in response to the light{" "}
            <b>(Acts 26:18, 1 Jhn 1:7).</b>
            <br />
            <br /> Whenever, the believer&rsquo;s eyes are enlightened to see
            the kingdom, he is empowered to turn from darkness and from his
            former ways that once seemed right. That turning is repentance{" "}
            <b>(Mk. 1:4, Luk. 24:47).</b> And with every cycle of turning or
            repentance, sins are being remitted. By this process of remission, a
            believer gains entrance into the kingdom of God{" "}
            <b>(1 Jhn. 2:12, Mat. 18:3, Mat. 19:13).</b>
          </Bullet>
          <br />
          <Bullet>
            <b>Being Washed (1 Cor. 6:11)</b>
            <br />
            Another perspective that the scriptures use to describe the process
            of becoming righteous, is being washed.
            <br />
            <br />
            <Picture src={water} />
            <br />
            <br /> Though the spirit of a believer is recreated at new birth,
            the soul is purchased, and added to the church so that he can be
            washed from the filth (the sins) that disqualifies him from entrance
            into the kingdom <b>(Eph. 5:26). </b>
            <br />
            <br />
            Sin is what makes a man filthy and disqualifies him from entrance
            into God&rsquo;s kingdom. As the word is preached, the soul is being
            washed from its sins <b>(Psa. 119:9, Jhn. 15:3).</b> The operation
            of washing the soul from sin is accomplished by the water of the
            word and the leading of the Spirit.
          </Bullet>
          <br />
          <Bullet>
            <b>Born of Water and of the Spirit (Jhn. 3:3&ndash;5)</b>
            <br />
            Although the new birth (to be born again) does not guarantee a
            believer of seeing the kingdom, it avails one the opportunity to see
            the kingdom <b>(Jhn. 3:3).</b> However, seeing the kingdom is not
            all, as the purpose of seeing is to enter the kingdom{" "}
            <b>(Jhn. 3:5).</b> Hence, being born of water and of the spirit, is
            a post&ndash;new birth experience. <br />
            <br />
            While the new birth is an activity that occured in the spirit
            instantaneously, being born of water and of the spirit is a process
            of conversion the soul has to undergo to be fit to enter the
            kingdom.
            <br />
            <br />
            <Italics>
              &#8220;Jesus answered, Verily, verily, I say unto thee, Except a
              man be BORN of WATER and of the SPIRIT, he cannot enter into the
              kingdom of God.&#8221; &ndash; <b>Jhn. 3:5</b>
            </Italics>{" "}
            <br />
            The &lsquo;water&rsquo; here does not speak of baptism by immersion,
            as this is simply a physical demonstration of what has happened in
            the spirit a believer, and has no impact on the soul. Neither does
            &lsquo;Spirit&rsquo; mean the baptism of the Holy Ghost, as this
            experience does not convert the soul for the kingdom but simply
            initiates the soul into the realm of the spirit. <br />
            <br />
            &lsquo;Water&rsquo; is used in several places in scripture to
            describe the word of the kingdom{" "}
            <b>(Eph. 5:26, Psa. 29:3&ndash;4).</b> Hence to be born of the water
            is to be born of the word.
            <br />
            <br />
            <Picture src={newBirth} />
            <br />
            <br />
            This is not a one&ndash;day experience, but is a process that occurs
            as a believer whose eyes are enlightened, gives himself consistently
            to hearing the word in hope of entering the kingdom. <br />
            <br />
            However, hearing the word of the kingdom is not the only engagement
            required to be fit for entrance, as the word will create an avenue
            for the hearer to be led by the Spirit. Hearing the word and not
            submitting to the leading of the Spirit will hinder conversion of
            the soul for the kingdom.
            <br />
            <br /> Hence, because of the word that has been received, the Spirit
            of the Lord directs, instructs, arranges situations, and subjects
            the believer to a condition or manner that will deal with sin in the
            soul, and form the lifestyle of righteousness in that believer.{" "}
            <br />
            <br />
            The leading of the Spirit is not haphazard, as it has a path and a
            destination (the kingdom of God) <b>(Psa. 23:3, Prov. 8:20).</b>
            It is to rid us of what sin had defined as our life. Therefore, to
            be born of the Spirit is to be subject to the leading of the Spirit
            until a man who is fit for entrance into the kingdom is born. <br />
            <br />
            One who has been born of water and spirit, has received remission of
            sins, has been washed, and is a righteous man who has ceased from
            seeking vanity to seek the kingdom of God. This is the man who can
            enter into the kingdom of God.
          </Bullet>
          <br />
          <Number number={2}>
            <b>Allegory of righteousness (2 Cor. 6:14&ndash;18, 1 Pet. 2:9)</b>
            <br />
            There are portions of scriptures that shows us righteousness for the
            Kingdom and righteousness of the Kingdom. The former is a
            prerequisite for the latter. By prerequisite, they are works of
            cleansing and washing to have entrance into the Kingdom of
            righteousness. In the kingdom of righteousness, we live and practice
            righteousness learnt until we become a king of righteousness.
            <br />
            <br /> We would be looking at allegories from scriptures that speak
            about this progression of righteousness. <b>
              Rom 1:16&ndash;17
            </b>{" "}
            clearly makes us see that righteousness is revealed from Faith to
            Faith. This means that there are levels of faith and hence levels of
            righteousness. The first level of righteousness is required for the
            next. It is a pre&ndash;requisite for the next. <br />
            <br />
            These levels of righteousness are seen from the scripture below as
            &#8220;Come out from amongst them&#8221; and &#8220;Be ye
            Separate&#8221;.
          </Number>
          <Italics>
            &#8220;Wherefore come out among them and be ye separate, saith the
            Lord, and touch not the unclean thing and I will receive you&#8221;
            &ndash; <b>2 Cor. 6:17</b>
          </Italics>
          <br />
          <Bullet>
            <b>Wherefore come out from among them</b> <br />
            This is the first level of righteousness. The process of coming out
            from among them is a separation from the heathen and from the
            gentiles. This is a cleansing process with the waters of Christ.
            This phase of righteousness is typified by the call of the children
            of Israel from Goshen in Egypt to the wilderness until they could
            camp around the Tabernacle of Service. <br />
            <br />
            There is a level of separation done here to make a disciple out of
            the believer. This class of believers is different from the
            believers in Egypt. The workings of Faith at this level cleanse and
            make a believer fit to enter the kingdom of God. The campers around
            the court of Moses Tabernacle can be said to have been fully called
            out and are waiting for entrance into the court of holiness, i.e.,
            the Levite courts.
          </Bullet>
          <br />
          <br />
          <Picture src={levites} />
          <br />
          <br />
          <Bullet>
            <b>Be ye separate</b> <br />
            The workings/teaching/operation of &#8220;Be ye Separate&#8221; is a
            separation done in the kingdom of God. It is the first cadre of the
            priesthood. The righteousness of Christ the New Man is perfected
            here until you become a King of righteousness. Here, you are
            separated unto priesthood and service of the good will of God.{" "}
            <br />
            <br />
            In this zone of righteousness, one is taught to overcome
            &#8220;worldly lust&#8221; and the wisdom of sin that is
            &#8220;carnal&#8221;. The righteousness learned without the camp is
            practiced here until you become a King of righteousness. A King of
            righteousness is ready to be made fit to enter into the next kingdom
            which is the Kingdom of Peace.
          </Bullet>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>Tenets of righteousness</Title>
          <Bullet>
            <b>Take no thought for your Life (Mat. 6:25&ndash;34)</b> <br /> The
            instruction of taking no thought for your life is a tenet of
            righteousness that overcomes the life of sin which every man has
            been trained with. It is a conversation that trains a soul on what
            the definition of &#8220;life&#8221; is. This teaches the soul that
            life is not in &#8220;food or raiment&#8221;.
            <br />
            <br />
            The Wisdom of Sin teaches man that our life consists in the things
            on earth. But righteousness this tenet of righteousness teaches a
            soul that Life is in the Kingdom and its righteousness
          </Bullet>
          <br />
          <Bullet>
            <b>Sell all that you have and follow me (Luk. 18:20&ndash;23)</b>{" "}
            <br />
            This is a demand of righteousness that teaches the soul to forfeit
            worldly treasures stored up in the heart and seek true riches. It is
            an obedience of &#8220;knocking&#8221; which shows your commitment
            to the Life of the Kingdom. Obedience to this commandment proves to
            the Lord that you desire the Kingdom.
          </Bullet>
          <br />
          <Bullet>
            <b>Living for the invisible (Heb. 11:1) </b>
          </Bullet>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>PEACE</Title>

          <br />
          <br />
          <Picture src={treeOfPeace} />
          <br />
          <br />
          <Content>
            A soul that has undergone forgiveness of sins and Sanctification by
            Righteousness is then made fit for entrance into the Kingdom of
            Peace. The strength of Sin which is dealt with here is Ungodliness.
            An ungodly man is one that is settled in a negative Peace which the
            world gives <b>(Jhn. 14:27).</b> <br />
            <br />
            The Peace of Worldliness makes a soul fit enough to learn
            &#8220;Iniquity&#8221;. Iniquity of the Kingdom of darkness makes a
            man learn the things that &#8220;destroys&#8221;{" "}
            <b>(Jhn. 10:10).</b>
            Destruction is the making of a soul to a state where he cannot
            respond to Salvation.
          </Content>
          <br />
          <Number number={1}>
            <b>Cleansing from ungodliness (Psalm 1)</b> <br />
            After a soul has reigned with righteousness, he will then be brought
            to learn &#8220;Peace&#8221;. Ungodliness is the highest stature of
            Flesh. Cleansing from ungodliness is a process of making a man free
            from the Law of Sin and death by the law of liberty in Christ Jesus.
            <br />
            <br />A Godly man has been cleansed, sanctified, and redeemed by the
            Law of Liberty in Christ Jesus. This man has come to peace with God
            and is settled enough to receive the Laws of God{" "}
            <b>Psa. 1:5&ndash;6</b> makes of see that the Lord
            &#8220;knows&#8221; the way of the righteous but the end of the
            ungodly is destruction.
          </Number>
          <br />
          <Number number={2}>
            <b>Being Redeemed (1 Cor. 1:30, Col. 1:13&ndash;14)</b> <br />
            We see clearly from 1 Cor 1:30, that Jesus is made us wisdom,
            righteousness, sanctification, and redemption. These are processes
            of cleansing and coming to God of which the end is redemption.
            Redemption means &#8220;buy back&#8221; or restoration. The
            translation of the believer from the Kingdom of darkness to the
            Kingdom of his dear Son was by the process of wisdom unto
            redemption. The process of being redeemed is done after
            sanctification by righteousness. <br />
            <br />
            This is the inheritance of Faith that is in Christ. When a soul is
            redeemed in Christ, he is made a new creature in Christ Jesus. Such
            a one has been redeemed from the world and unto God. The Redemption
            of a Soul by the Kingdom of Righteousness and Peace qualifies the
            soul for Salvation in the Kingdom of Joy.
          </Number>
          <Number number={3}>
            <b>Learning Charity (1 Tim. 1:5, 1 Cor. 13:13)</b> <br />
            <Italics>
              &#8220;And now abideth faith, hope, these three; but the greatest
              of these is Charity&#8221; &ndash; 1 Cor. 13:13
            </Italics>
            1 John 2:17 makes us see that the world passeth away and the lust
            thereof, but they that do the will of God abideth forever. We also
            see from the scripture above that Faith, hope and Charity abideth in
            Christ, but the greatest is Charity. This means that Charity which
            is the peak of learning Christ is makes a soul perfect in Christ
            (Col. 3:14). <br />
            <br />
            The learning of Christ is what saves a man from the world and makes
            him to abide in the good and acceptable will of God. Every
            allocation of God&rsquo;s Word has its love expression. The love
            expression of the Milk of Gods Work is &#8220;Love unto all the
            saint&#8221;. The Meat of God&rsquo;s Word which is the teaching of
            Christ also have a higher love expression. This is Charity. It is
            called the love of the brethren <b>(1 Pet. 1:22).</b>
            <br />
            <br />
            <Picture src={brotherlyLove} />
            <br />
            <br />
            Charity is not a mechanical display of actions but the formation of
            a nature in the soul. Charity is a state in Christ in which the
            believer cannot be moved by anything earthly/worldly. Such a
            believer has come into peace in which the hope of the soul is God.{" "}
            <br />
            <br />A charity man is fulfilled without any Glory in the world. He
            is a contented man, a perfect man, a godly man <b>
              (1 Pet. 1:22).
            </b>{" "}
            Before a man can walk in the love of the brethren (charity), he must
            have learnt to walk by faith and must have had his hope purified.
            Charity which is the end of the commandment <b>(1Tim 1:5)</b> can be
            seen in two phases. Charity unto the brethren{" "}
            <b>(1 Cor. 13:4&ndash;5)</b> and Charity unto God{" "}
            <b>(1 Cor. 13:6&ndash;7).</b>
          </Number>
          <br />
          <br />
          <Picture src={tenCommandments} />
          <br />
          <br />
          <Bullet>
            <b>The Expression of Charity unto the brethren </b>
            The Expression of Charity unto the brethren is &#8220;unfeigned love
            of the brethren&#8221;. This is love without dissimulation and
            strife. Charity is also to be learnt and practiced. The brethren
            here are a community of believers who have the hope of Eternal Life
            as their Hope and are journeying towards it. <br />
            <br />
            This expression of Love teaches you to serve one another and regard
            him/her better than yourself. Charity towards your brethren is one
            that is devoid of worldly lust and self&ndash;gain. It is sincere
            and pure one to another and unto God. The Learning of Charity unto
            the brethren is needed to train the soul in Love and prepare such
            one for the &#8220;Love of God&#8221; <b>(1 Jhn. 4:20).</b> This is
            because the demand for the Love of God is higher than the
            &#8220;Love of the brethren&#8221;.
          </Bullet>
          <br />
          <Bullet>
            <b>The Expression of Charity towards God </b> is simply expressed in
            &#8220;Looking diligently/earnestly&#8221; for the blessed Hope{" "}
            <b>(Heb. 12:15). </b>
            It is defined as the Love of the Father in 1 Jhn. 2:15. &#8220;Love
            of the Father&#8221; here is love for the things of the Father. It
            is a love expression of the soul for the Everlasting kingdom, which
            is the Life of the Father. This Charity expression rejoiceth in the
            truth that is in the Father and seeks it earnestly.
          </Bullet>
          <br />
          <Italics>
            &#8220;Therefore the redeemed of the Lord shall return, and come
            with singing unto Zion, and everlasting joy shall be upon their
            head: they shall obtain gladness and Joy; and sorrow and mourning
            shall flee away.&#8221; &ndash; <b>Isa. 51:11</b>
          </Italics>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>Allegory of Peace</Title>
          <Italics>
            &#8220;Wherefore come out among them and be ye separate, saith the
            Lord, and touch not the unclean thing and I will receive you&#8221;
            &ndash; <b>2 Cor. 6:17</b>
          </Italics>
          <br />
          <br />
          <Picture src={allegory} />
          <br />
          <br />
          <Content>
            The Kingdom of Peace is a place of full justification of Christ for
            making Peace with God <b>(Rom. 5:1).</b> In the Kingdom of Peace, we
            are brought up to a good standing where we can see God{" "}
            <b>(Mat. 5:8).</b> There are several allegories of peace seen in
            scriptures. <br />
            <br />
            Looking at the scriptures, we can see various allegories of the
            Kingdom. From the Scripture above, the operation of &#8220;Touch not
            the unclean&#8221; is through the teaching of Holiness{" "}
            <b>(1 Thess. 4:7).</b> The kingdom of Christ makes a new man who is
            created after God in righteousness and true holiness. We can safely
            say that the teaching of touch not the unclean is by the making of
            Holiness. Allegories of the Kingdom of Peace are:
          </Content>

          <Bullet>
            The Second Heaven which is the habitation of the host of the Lord
            also known as Seraphims. They are beings of Holiness or beings of
            Peace
          </Bullet>
          <Bullet>
            The Sanctuary or Holy Place, according to the Tabernacle that Moses
            pitched
          </Bullet>
          <Bullet>
            According to Melchizedek priesthood, the expression of peace is seen
            as &#8220;The King of Peace&#8221;
          </Bullet>
          <Content>
            In Peace, the cleansing from the World is complete and the soul is
            able to receive the things of Salvation.{" "}
          </Content>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>Tenets of Peace (Heb 12:10&ndash;14)</Title>
          <Bullet>
            Esteem your brother better than yourself <b>(Phi.2:2&ndash;4)</b>
            <br />
            The teachings of the Peace that is in Christ are seen in meekness
            and lowliness of mind. It teaches us to the lower cadre and exalt
            others more than ourselves. This mind of putting your brother before
            yourself will removes selfishness and eventually eliminates all
            forms of competition and strife from amongst the brethren. This
            eventually brings about oneness or unity in love
          </Bullet>
          <br />
          <Bullet>
            Bear ye one another&rsquo;s burden and think of yourself not more
            highly than ye ought to <b>(Gal. 6:2&ndash;3, Rom. 12:3)</b>
          </Bullet>
          <br />
          <Bullet>Godliness with contentment is great gain</Bullet>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>Conclusion</Title>
          <Content>
            Today, by God&rsquo;s grace, we have been able to expound the
            kingdom of Christ in much detail. Specifically, we looked at the
            subject of sin, the world, and flesh. In addition, we saw how the
            kingdom of Christ delivers the soul from dominion of sin and death.
            Next, we will be considering the everlasting kingdom, which is the
            kingdom of God in our next class.
          </Content>
        </SubSection>
      </Section>
      <WithLove />
    </>
  );
}
